"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContractRead = void 0;
const react_1 = require("react");
const chain_1 = require("../utils/chain");
const useContractRead = ({ chainName, contractDetails, }) => {
    const [data, setData] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isError, setIsError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const read = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setIsLoading(true);
                const wallet = new chain_1.ChainController(chainName);
                const res = yield wallet.readContract(contractDetails);
                setData(res.data);
                setIsLoading(false);
            }
            catch (err) {
                setData(null);
                setIsError(true);
            }
        });
        if (chainName && contractDetails)
            read();
    }, []);
    return { data, isLoading, isError, isSuccess: !!data };
};
exports.useContractRead = useContractRead;
